import React from 'react';
import ReactMarkdown from 'react-markdown';
import { Row, Col, Container } from 'reactstrap';
import raw from 'raw.macro';
import gfm from 'remark-gfm';
import { useHistory, useLocation } from 'react-router-dom';

const api = raw('../../markdowns/API/Api.md');
const apiSide = raw('../../markdowns/API/Api-side.md');
const webhooks = raw('../../markdowns/API/Webhooks.md');
const webhooksSide = raw('../../markdowns/API/Webhooks-side.md');
const standalone = raw('../../markdowns/API/Standalone.md');
const standaloneSide = raw('../../markdowns/API/Standalone-side.md');
const standaloneUILess = raw('../../markdowns/API/Standalone-ui-less.md');
const standaloneUILessSide = raw('../../markdowns/API/Standalone-ui-less-side.md');

const selector = (location, side) => {
    switch (location) {
        case '/api/docs/webhooks': return side ? webhooksSide : webhooks;
        case '/api/docs/standalone': return side ? standaloneSide : standalone;
        case '/api/docs/standalone-sin-ui': return side ? standaloneUILessSide : standaloneUILess;
        default: return side ? apiSide : api;
    }
}

export default function ApiDocs() {

    const { pathname } = useLocation();
    const history = useHistory();
    const handleGoTo = (location) => {
        switch (location) {
            case 'webhooks': history.push('/api/docs/webhooks'); break;
            case 'standalone': history.push('/api/docs/standalone'); break;
            case 'standalone-sin-ui': history.push('/api/docs/standalone-sin-ui'); break;
            default: history.push('/api/docs'); break;
        }
    }
    return (
        <Container fluid className="overflow-hidden h-100 api-documentation">
            <Row className="h-100">
                <Col md="3" sm="12" className="h-100 d-none d-md-block">
                    <div className="p-3 p-md-1 overflow-auto h-100">
                    <img src="/images/logo-01.svg" alt="logo" width="150px"></img>
                    <div className="clear-fix my-4"></div>
                    <a className="site" href="#" title="TRATO API"></a>
                    <a className="extension" href="#" onClick={() => handleGoTo('api/docs')} style={{color:'#0f4f79'}}><h1>REST API</h1></a>
                    <ReactMarkdown
                        escapeHtml={false}
                        plugins={[gfm]}
                        source={selector(pathname, true)}
                    />
                    <nav>
                        <ul>
                            <li onClick={() => handleGoTo('api')}>
                                <a href="#">API</a>
                            </li>
                            <li onClick={() => handleGoTo('webhooks')}>
                                <a href="#">Webhooks</a>
                            </li>
                            <li onClick={() => handleGoTo('standalone')}>
                                <a href="#">Standalone</a>
                            </li>
                            <li onClick={() => handleGoTo('standalone-sin-ui')}>
                                <a href="#">Standalone sin ui</a>
                            </li>
                        </ul>
                    </nav>
                    </div>
                </Col>
                <Col md="9" className="p-5 bg-white h-100" style={{ overflowY: 'scroll',overflowX: 'hidden'}} id="content">
                    <ReactMarkdown
                        escapeHtml={false}
                        plugins={[gfm]}
                        source={selector(pathname)}
                    />
                </Col>
            </Row>
        </Container>
    )
}